$(function()
{
    var _container = null;
    var _show = null;
    var _showTemplate = null;

    function copyToView(statute)
    {
        //scrollToView();

        //hideView();

        var html = _showTemplate;

        html = html.split('*|TITLE|*').join(statute.title);
        html = html.split('*|CONTENT|*').join(statute.content);
        html = html.split('*|INTRO|*').join(statute.intro);

        _container.html(html);

        //showView();
    }

    function hideView()
    {
        _container.slideUp();
    }

    function showView()
    {
        _container.slideDown();
    }

    function scrollToView()
    {
        rsScrollTo((_container.offset().top - 105 - 20), 500);
    }

    function init()
    {
        $('.js__statute-item').bind('click', function(e){
            e.preventDefault();

            copyToView(STATUTES[$(this).data('target')]);
        });

        copyToView(STATUTES[0]); // Init first item
    }

    $(document).ready(function(){
        _container = $('.js__statutes-container');
        _show = $('.js__statute-show');

        _show.hide();

        _showTemplate = $('.js__statute-show').html();

        init();
    });
});